/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Actions_Not_EnabledInputs */

const es_user_profile_api_keys_actions_not_enabled = /** @type {(inputs: User_Profile_Api_Keys_Actions_Not_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan de tu empresa no incluye acceso a API Keys`)
};

const en_user_profile_api_keys_actions_not_enabled = /** @type {(inputs: User_Profile_Api_Keys_Actions_Not_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your company's plan does not include API key access`)
};

/**
* | output |
* | --- |
* | "Your company's plan does not include API key access" |
*
* @param {User_Profile_Api_Keys_Actions_Not_EnabledInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_actions_not_enabled = /** @type {((inputs?: User_Profile_Api_Keys_Actions_Not_EnabledInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Actions_Not_EnabledInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_actions_not_enabled(inputs)
	return en_user_profile_api_keys_actions_not_enabled(inputs)
});
export { user_profile_api_keys_actions_not_enabled as "user.profile.api_keys.actions.not_enabled" }